import React from "react";

/**
 * Muted, looping YouTube video used as a section background.
 *
 * YouTube has no true "cover" mode, so the iframe is sized to 16:9 and scaled up
 * from the centre to fill whatever box it sits in - the same trick used for
 * full-bleed video headers. It is inert (pointer-events-none) so it never
 * intercepts clicks from the content layered above it.
 */
export default function VideoBackground({ videoId, opacity = 0.45, poster }) {
  if (!videoId) return null;

  const src =
    `https://www.youtube.com/embed/${videoId}` +
    `?autoplay=1&mute=1&controls=0&loop=1&playlist=${videoId}` +
    `&playsinline=1&modestbranding=1&rel=0&disablekb=1&fs=0&iv_load_policy=3`;

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true" data-testid="video-background">
      {/* still frame underneath so there is never a flash of empty black */}
      {poster && <img src={poster} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      <iframe
        title="Background video"
        src={src}
        allow="autoplay; encrypted-media"
        allowFullScreen={false}
        tabIndex={-1}
        className="pointer-events-none absolute left-1/2 top-1/2 h-[calc(100vw*9/16)] min-h-full w-[100vw] min-w-[calc(100vh*16/9)] -translate-x-1/2 -translate-y-1/2 border-0"
        style={{ opacity }}
      />
    </div>
  );
}
